export enum ShiftViolation {
  MinBreakTime = '0',
}

export interface ShiftReport {
  shiftId: string;
  shiftViolationIds: ShiftViolation[];
  comment: string | null;
}
